import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { formatAsCurrency, MyProfileData } from 'cpfr-common';
import { Button, ButtonContainer, Notification } from '@vwfs-bronson/bronson-react';
import { createUnpaidNoticationBtnUrl } from './utils';

export type UnpaidAlertNotificationProps = {
    amountUnpaidNotPaid?: number;
    contractId?: string;
    myProfile?: MyProfileData;
};

export const UnpaidAlertNotificationUi: React.FC<UnpaidAlertNotificationProps> = ({
    amountUnpaidNotPaid,
    myProfile,
    contractId,
}) => {
    const { t } = useTranslation('contracts');

    if (!amountUnpaidNotPaid || amountUnpaidNotPaid <= 0) {
        return null;
    }

    const [href, setHref] = useState('#');

    useEffect(() => {
        async function fetchUrl() {
            if (!myProfile) return;
            const url = await createUnpaidNoticationBtnUrl(
                myProfile.identification?.customerType || '',
                contractId ?? '',
            );
            setHref(url ?? '#');
        }

        fetchUrl();
    }, [myProfile]);

    return (
        <Notification
            status={NotificationStatus.warning}
            title={t('unpaid-alert.headline')}
            testId={'active-contract-unpaid-alert'}
            className={'u-mv'}
            visible
            showCloseButton={false}
        >
            {t('unpaid-alert.text-unpaid-ammount', { value: formatAsCurrency(amountUnpaidNotPaid) })}
            <br />
            {t('unpaid-alert.text-support')}
            <ButtonContainer>
                <Button
                    element="a"
                    link
                    className="u-mt"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t('unpaid-alert.aria-title-btn')}
                    title={t('unpaid-alert.aria-title-btn')}
                    icon="semantic-forward"
                >
                    {t('unpaid-alert.btn-text')}
                </Button>
            </ButtonContainer>
        </Notification>
    );
};
